import React, { Component } from 'react';
import { withRouter } from '../../../util/withRouter';
import { connect } from 'react-redux';
import { Button } from 'react-bootstrap';
import Header from '../../../components/Header/Header';

import { error, revokeRequest } from '../../Users/UsersActions';

import illustration from '../../../assets/img/illustrations/awaiting.png';

// Import Style
import '../style.scss';

class AwaitingPage extends Component {
  revokeRequest = () => {
    this.props.revokeRequest();
  };

  render() {
    const isSso = this.props.route.path.toLowerCase() === 'awaiting/sso';

    return (
      <div className='main welcome'>
        <Header title="" showHome={false} />
        <div className='centerContent'>
          <h1 className='title'>
            Awaiting
            <br /> authentication
          </h1>
          <p>
            We’ve notified your account managers!
            <br />
            Once your request is approved, you’ll be able to access your corporate account.
          </p>
          <div className='icon'>
            <img src={illustration} alt="" />
          </div>
          {!isSso && (<div className='content-options'>
            <Button onClick={() => this.revokeRequest()}>
              Revoke request
            </Button>
          </div>)}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    revokeRequest: () => dispatch(revokeRequest(true)),
    setError: err => dispatch(error(err))
  };
};

const mapStateToProps = state => {
  return {
    user: state.auth.user
  };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(AwaitingPage));
